<template>
	<div>
		<departmentList dictionaryCode="POSITIONAL_TITLE"></departmentList>
	</div>
</template>

<script>
export default {
	name: 'titleList',
	components: {
		departmentList: () => import('../departmentList/index.vue'),
	},
};
</script>

<style lang="scss" scoped>
</style>